<template>
  <div>
    <Card title="Users" icon="mdi-home-group">
      <EditableTable
        :table-subscription="(handler) => this.$api.user.subscribeAll(handler)"
        :fields="[
          {fieldName:'id', displayName: 'Id', type: String},
          {fieldName:'name', displayName: 'Name', editable: false, type: String, rules:[]},
          {fieldName:'verifiedEmailAddress', displayName: 'Email', editable: false, type: String, rules:[]},
          {fieldName:'username', displayName: 'Username', editable: false, type: String, rules:[]},

          {fieldName:'enabled', displayName: 'Enabled', editable: true, type: Boolean, rules:[]},
          ]"
        :save-method="(data) => this.$api.user.saveUserAdmin(data)"
      />
    </Card>
  </div>
</template>

<script>
import Card from '@/components/Card'
import EditableTable from '@/components/EditableTable'
export default {
  name: 'AdminUsers',
  components: { EditableTable, Card },
}
</script>

<style scoped>

</style>
